import Request from 'redux/config/services/Request'

export const getProperties = async (): Promise<object> => {
  const response = await Request.get('/core/properties')
  return response.data
}
